import { TEXTAREA_MAX_VISIBLE_LINES_COMPACT, TEXTAREA_MAX_VISIBLE_LINES_DEFAULT, TEXTAREA_LINE_HEIGHT_PX, TEXTAREA_PADDING_TOP_PX } from './aiAskBarLayoutConstants'

export function useAiAskBarComposerFlags({ isComposerVariant, effectiveStackedToolbar, composerPlainText, attachments, replyPreview, refinementText, sendDisabled, onSend }) {
  const trimmedComposer = composerPlainText.trim()
  const isMultiline = composerPlainText.includes('\n') || composerPlainText.split('\n').length > 1
  const isExpanded = isComposerVariant ? effectiveStackedToolbar || isMultiline || attachments.length > 0 || Boolean(replyPreview) || Boolean(refinementText) : true
  // Only 'uploading' is pending: until the POST returns there is no document id
  // to put in doc_scope. A saved-but-unparsed document is fine to send — the
  // agent prepares it mid-turn when the question needs it. A failed attachment
  // blocks too — sending it would silently drop it from doc_scope, so the user
  // removes or retries it first (the chip says why).
  const hasPendingAttachment = attachments.some((item) => item.uploadState === 'uploading')
  const hasFailedAttachment = attachments.some((item) => item.uploadState === 'error')
  const sendIsActive = Boolean(onSend) && !sendDisabled && !hasPendingAttachment && !hasFailedAttachment && (trimmedComposer.length > 0 || attachments.length > 0)
  const textareaMaxVisibleLines = isComposerVariant ? TEXTAREA_MAX_VISIBLE_LINES_COMPACT : TEXTAREA_MAX_VISIBLE_LINES_DEFAULT
  const textareaMaxHeightPx = TEXTAREA_PADDING_TOP_PX + textareaMaxVisibleLines * TEXTAREA_LINE_HEIGHT_PX

  return {
    trimmedComposer,
    isMultiline,
    isExpanded,
    sendIsActive,
    textareaMaxHeightPx,
  }
}
